import React from 'react'

function SSOAPI() {
  return (
    <div></div>
  )
}

export default SSOAPI